import { isDefined, LocationTypeEnum } from "@perxis-auto/shared/lib";
function isLocationItem(value) {
  if (typeof value !== "object" || !isDefined(value)) {
    return false;
  }
  return "id" in value && "name" in value && "type" in value && isDefined(value.id) && isDefined(value.name) && [LocationTypeEnum.City, LocationTypeEnum.Cluster].includes(value.type);
}
export {
  isLocationItem
};
